export default __webpack_public_path__ + "static/media/wbc-logo-white-web.2f7e59b6.png";